import React, { useState, useEffect } from "react";
import { IoMdSearch } from "react-icons/io";
import Modal from "react-modal";
import Plan from "./Plan";
import Package from "../assets/images/Home/Package.svg";
import { GoDownload } from "react-icons/go";
import LoadingSpinner from "../components/LoadingSpinner";
import Pagination from "../components/Pagination";
import Plus from "../assets/images/Home/Plus.svg";
import { toast } from "react-toastify";
import { ImCross } from "react-icons/im"; // Import the cross icon
import Premium from "../assets/images/Home/Premium.svg";
import Standard from "../assets/images/Home/Standard.svg";
import iota from "../assets/images/New_Jul_2025/iota.svg";

const BuyStandardplan = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const role = localStorage.getItem("role");
  const [error, setError] = useState(null);

  const itemsPerPage = 10;
  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const [packageType, setPackageType] = useState(null);
  const [hovered, setHovered] = useState("");
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 }); // To store cursor position
  const [description, setDescription] = useState(""); // New state for description

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "Payaspergo") {
      setSelectedPackageType("Standard");
      setPackageType("");
    } else {
      setSelectedPackageType("Premium");
      setPackageType("voicedata");
    }
  }, []);

  const premiumPackageTypes = ["voicedata", "data"];
  const standardPackageTypes = ["", "Daily"];

  useEffect(() => {
    const cached = sessionStorage.getItem("cachedPlans");
    if (cached) {
      setPlans(JSON.parse(cached));
      return;
    }

    const fetchPlans = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const partnerCode = localStorage.getItem("partnerCode");
        const response = await fetch(
          `${apiUrl}ESIM/Get_all_plans?flag=1&PartnerCode=${partnerCode}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data.isSuccess) {
          const sortedPlans = data.getallplan.sort((a, b) =>
            a.country.localeCompare(b.country)
          );
          // Immediately load first 10 plans for quick UI response
          setPlans(sortedPlans.slice(0, 10));

          // Cache entire dataset for later use
          sessionStorage.setItem("cachedPlans", JSON.stringify(sortedPlans));

          // Load full data in background
          setTimeout(() => {
            setPlans(sortedPlans);
          }, 0); // Set as soon as current render finishes
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // reset to first page whenever search changes
  };

  const filteredPlans = plans.filter((plan) => {
    const isPremiumPlan =
      plan.plan_type === "Premium_plan" &&
      plan.plan_Class === packageType &&
      plan.country.toLowerCase().includes(searchQuery.toLowerCase());

    const isStandardPlan =
      plan.plan_type === "Standard_plan" &&
      (packageType === ""
        ? plan.plan_datatype === ""
        : plan.plan_datatype === packageType) &&
      plan.country.toLowerCase().includes(searchQuery.toLowerCase());

    return isPremiumPlan || isStandardPlan;
  });

  const totalPages = Math.ceil(filteredPlans.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPlans = filteredPlans.slice(indexOfFirstItem, indexOfLastItem);

  const handleBuyClick = (plan) => {
    localStorage.setItem("planCode", plan.plancode);
    localStorage.setItem("plan_id", plan.planid);
    setSelectedPlan(plan);
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);
  const downloadCSV = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const partnerCode = localStorage.getItem("partnerCode");

      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const response = await fetch(
        `${apiUrl}ESIM/Get_all_plans?flag=1&PartnerCode=${partnerCode}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      const data = await response.json();
      if (data.isSuccess) {
        let { getallplan } = data;
        getallplan = getallplan.sort((a, b) =>
          a.country.localeCompare(b.country)
        );

        const header =
          "Country,Data,Validity,Portal Price,plan_Class,plan_type,connectivity,plancode,countries_covered\n";
        const discount = parseFloat(localStorage.getItem("Discount")) || 20;

        const rows = getallplan
          .map((plan) => {
            const portalPrice = parseFloat(plan.sellingcost);
            const websitePrice = portalPrice * (1 - discount / 100);
            return `${plan.country},${
              plan.data === "" ? "Unlimited" : plan.data
            },${plan.validity},$${portalPrice.toFixed(2)},${plan.plan_Class},${plan.plan_type},${
              plan.connectivity
            },${plan.plancode},"${plan.countries_covered}"`;
          })
          .join("\n");

        const csvContent = header + rows;
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "plans.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const currentPackageOptions =
    selectedPackageType === "Premium"
      ? premiumPackageTypes
      : standardPackageTypes.map((type) =>
          type === "" || type === null ? "fixed" : type
        );

  const addToCart = (plan) => {
    const existing = JSON.parse(localStorage.getItem("cartPlans") || "[]");

    // Check if plan with same plancode already exists
    const alreadyExists = existing.some((p) => p.plancode === plan.plancode);
    if (alreadyExists) {
      toast.error("This plan is already in the cart.");
      return;
    }

    // Optional: limit total number of plans in cart
    if (existing.length >= 10) {
      toast.error("You can only add up to 10 plans to the cart.");
      return;
    }

    const updated = [...existing, { ...plan, quantity: plan.quantity || 1 }];
    localStorage.setItem("cartPlans", JSON.stringify(updated));
  };

  const handleHover = (e, type) => {
    setHovered(type);
    setCursorPosition({ x: e?.clientX || 0, y: e?.clientY || 0 }); // Update cursor position on hover

    if (type === "voicedata") {
      setDescription("High-speed plans with local number, calls and texts.");
    } else if (type === "data") {
      setDescription(
        "High-speed, low-latency plans with fixed or unlimited data."
      );
    } else if (type === "fixed") {
      setDescription("Fixed data plans with low latency and recharge option.");
    } else if (type === "Daily") {
      setDescription("Daily unlimited plans with speed cap after fair usage.");
    } else {
      setDescription(""); // Reset description for any other hover
    }
  };

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
      )}

      <div className="flex items-center">
        <div className="flex space-x-8">
          {["Premium", "Standard"].map((type) => {
            const role = localStorage.getItem("role");
            if (role === "Payaspergo" && type === "Premium") return null;

            return (
  <div
  key={type}
  onClick={() => {
    setSelectedPackageType(type);

    if (type === "Standard") {
      setPackageType("");
    } else if (type === "Premium") {
      setPackageType("voicedata");
    }
  }}
  onMouseEnter={(e) => handleHover(e, type)}
  onMouseLeave={() => setHovered("")}
  className={`rounded-3xl h-8 flex items-center justify-start p-2 border  ${
    selectedPackageType === type
      ? "bg-[#FFFFFF] text-[#232323] text-5xl font-bold  p-12 border-[#83b1ab]"
      : "text-[#718EBF] p-12"
  }`}
>
  {/* Left Side: Image */}
  <div className="flex-shrink-0">
    {type === "Premium" ? (
      <img
        src={Premium}
        className="p-2 w-12 border-1 bg-[#e7ffee] rounded-full"
        alt="Premium"
      />
    ) : (
      <img
        src={Standard}
        className="p-2 w-12 border-1 bg-[#d9e4f4] rounded-full"
        alt="Standard"
      />
    )}
  </div>

  {/* Right Side: Text */}
  <div className="ml-2">
    <div className="text-center">
      <h1
        className={`text-[1.2rem]  ${
          type === "Premium" ? "text-black" : "text-[#6d8bbb]"
        }`} // Conditional color based on plan type
      >
        {type === "Premium" ? "Premium Plans" : "Standard Plans"}
      </h1>
    </div>

    <div className="text-center mt-1">
      <p
        className={`text-xs ${
          type === "Premium" ? "text-[#41918a]" : "text-[#a8c0e8]"
        }`} // Conditional color for "Best Value" vs "Basic Packs"
      >
        {type === "Premium" ? "Best Value" : "Basic Packs"}
      </p>
    </div>
  </div>
</div>


            );
          })}
          {/* Show description only on hover */}
          {/* Show description only on hover */}
          {description && (
            <div
              style={{
                position: "absolute",
                top: cursorPosition.y + 10, // Position below the cursor
                left: cursorPosition.x + 10, // Position to the right of the cursor
                backgroundColor: "#f1f1f1",
                padding: "8px",
                borderRadius: "6px",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                zIndex: 9999,
              }}
              className="text-sm text-gray-700"
            >
              {description}
            </div>
          )}
        </div>
        <div className="flex-grow" />

        {/* Search */}
        <div className="bg-[#117575] p-3 mb-2 w-96 rounded-xl">
          <div className="relative">
            <input
              type="text"
              placeholder="Search Countries"
              className="w-full rounded-2xl bg-brand-gray h-8 pl-10"
              value={searchQuery}
              onChange={handleSearch}
            />
            <div className="absolute inset-y-0 left-0 flex items-center pl-3">
              <IoMdSearch size={20} className="text-gray-500" />
            </div>
          </div>
        </div>
      </div>

      {/* Package Type Options */}
      {/* Package Type Options */}
      <div className="flex space-x-8 p-6 mt-5  rounded-lg bg-[#ffffff]">
        {currentPackageOptions.map((type) => (
          <div
            key={type}
            onClick={() => setPackageType(type === "fixed" ? "" : type)}
            onMouseEnter={(e) => handleHover(e, type)}
            onMouseLeave={() => {
              setHovered("");
              setDescription("");
            }}
            className={`cursor-pointer text-lg font-bold ${
              packageType === (type === "fixed" ? "" : type)
                ? "text-[#105255] border-b-4 border-[#117575]"
                : "text-[#8ca3cb]"
            }`}
          >
            {type === "fixed"
              ? "Fixed Data"
              : type === "voicedata"
              ? "Voice + Data"
              : type.charAt(0).toUpperCase() + type.slice(1)}
          </div>
        ))}
      </div>

      {/* Plans Table */}
      {plans.length > 0 && (
        <div className=" p-2 border border-gray-300 shadow-md rounded-lg bg-[#ffffff]">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center">
              <img src={Package} alt="package" className="w-8 h-8 mb-1" />
              <span className="ml-3 text-5xl text-black font-bold">
                Packages
              </span>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={downloadCSV}
                className="px-4 py-2 text-[#105255] rounded-md font-bold flex items-center space-x-2"
              >
                <GoDownload size={28} />
                <span>Export</span>
              </button>
            </div>
          </div>

          <div className="overflow-y-auto">
            <table className="w-full">
              <thead className="sticky top-0 bg-gray-200">
                <tr className="border-b">
                  <th className="text-center p-3">Country/Region</th>
                  <th className="text-center p-3">Data</th>
                  <th className="text-center p-3">Validity</th>
                    {/* Conditionally render the "Renewal" header */}
                 {selectedPackageType === "Premium" && packageType === "voicedata" && (
                  <th className="text-center p-3">Voice</th>
                )}

                  <th className="text-center p-3">Plan Code</th>
                  {role === "Partner" && (
                    <>
                      <th className="text-center p-3">Price</th>
                    </>
                  )}
                  {/* Conditionally render the "Renewal" header */}
                  {selectedPackageType === "Premium" && (
                    <th className="text-center p-3">Renewal</th>
                  )}
                  <th className="text-center p-3">Operator</th>
                  <th className="text-center p-3">Add to Cart</th>
                  <th className="text-center p-3">Buy</th>
                </tr>
              </thead>
              <tbody>
                {currentPlans.length > 0 ? (
                  currentPlans.map((plan) => (
                    <tr
                      key={plan.planid}
                      className="border-b hover:bg-gray-100"
                    >
                      <td className="text-center ">
                        <div className="flex justify-start ml-11">
                          {" "}
                          <img
                            src={`https://www.airhubapp.com/assets/flags/${plan.country}.svg`}
                            alt={`${plan.country} flag`}
                            className="w-8 h-8 mr-2"
                          />
                          <span style={{ lineHeight: "2" }}>
                            {plan.country}
                          </span>
                        </div>
                      </td>
                      <td className="text-center p-1">
                        {plan.data || "Unlimited"}
                      </td>
                      <td className="text-center p-1">{plan.validity}</td>
                      {selectedPackageType === "Premium"  && packageType === "voicedata" &&  (
                      <td className="text-center p-1">
                        <div className="flex items-center gap-x-2 relative">
                        {/* Left image (Plus) */}
                        <div className="flex-shrink-0">
                          <img src={Plus} alt="Plus" />
                        </div>

                        {/* Right image (iota) with tooltip */}
                        <div className="relative group flex-shrink-0">
                          <img src={iota} alt="iota" className="cursor-pointer" />
                          <div className="absolute bottom-full  p-2 mb-2 hidden group-hover:block bg-[#217668] text-white text-xs z-10 whitespace-nowrap">
                            {plan.remarks}
                          </div>
                        </div>
                      </div>
                      </td>
                    )}
                      <td className="text-center p-1">{plan.plancode}</td>
                      {role === "Partner" && (
                        <>
                          <td className="text-center p-3 px-5">
                            ${plan.sellingcost}
                          </td>
                        </>
                      )}
                    {selectedPackageType === "Premium" && (
                    <td className="text-center p-1">
                      {plan.recharge == 1 ? (
                        <div className="flex justify-center items-center">
                          <img src={Plus} alt="Plus" />
                        </div>
                      ) : plan.recharge == 2 ? (
                        <span>-</span>
                      ) : (
                        "-"
                      )}
                    </td>
                  )}

                      <td className="text-center p-1">{plan.operatorname}</td>
                      <td className="text-center">
                        <button
                          className="rounded-2xl items-center px-3 py-2 m-1 text-[#217668] border-2 focus:outline-none hover:outline-none"
                          style={{
                            outline: "2px solid #217668", // Red outline
                          }}
                          onClick={() => addToCart(plan)}
                        >
                          Add to cart
                        </button>
                      </td>

                      <td className="text-center">
                        <button
                          className="rounded-lg bg-[#117575] items-center p-3 m-1 text-brand-white"
                          onClick={() => handleBuyClick(plan)}
                        >
                          Buy Now
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center p-4">
                      No Plan for this condition
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
          {/* Modal for buying plan */}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
              content: {
                width: "80%",
                margin: "auto",
                padding: "0px",
                borderRadius: "8px",
                height: "fit-content",
              },
            }}
          >
            <div className="absolute top-4 right-5 flex justify-center items-center">
              <button onClick={closeModal} className="text-black">
                <ImCross size={20} />
              </button>
            </div>
            {selectedPlan && (
              <Plan plan={selectedPlan} closeModal={closeModal} />
            )}
          </Modal>
        </div>
      )}
    </>
  );
};

export default BuyStandardplan;
